module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mail-builder/mail-builder.component.html
// module id = ./src/app/mail-builder/mail-builder.component.html
// module chunks = main